import LayoutContainer from './LayoutSwitcherContainer'

export default LayoutContainer
